// components/SidePdfOverlay.tsx
import { Drawer, Box, IconButton, Typography, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PDFPreview from "./PDFPreview"; // <-- your existing component

type SidePdfOverlayProps = {
  open: boolean;
  onClose: () => void;
  fileUrl: string | null;
  pageNumber?: number | null; // default 1
  title?: string; // optional header title
  width?: number | string; // e.g. "45vw" | 520
};

export default function SidePdfOverlay({
  open,
  onClose,
  fileUrl,
  pageNumber = 1,
  title = "Document",
  width = "45vw",
}: SidePdfOverlayProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      // no backdrop -> underlying UI stays interactive
      ModalProps={{ keepMounted: true, hideBackdrop: true }}
      PaperProps={{
        sx: {
          width,
          minWidth: 420,
          boxShadow: 8,
          height: "98vh",
          borderLeft: (t) => `1px solid ${t.palette.divider}`,
        },
      }}
      variant="persistent"
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 1.5,
        }}
      >
        <Box></Box>
        <Typography variant="subtitle1" sx={{ flex: 1 }} noWrap></Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />

      {/* Content area */}
      <Box sx={{ p: 2, height: "100%", overflow: "auto" }}>
        <PDFPreview
          variant="inline"
          fileUrl={fileUrl}
          pageNumber={pageNumber}
          height={600}
          showHeader
        />
      </Box>
    </Drawer>
  );
}
